import { getFieldCopy, type FieldCopy, type LocaleKey } from "@/i18n";
import { TelephoneField, type TelephoneFieldProps } from "../telephone-field";
import type { FieldPath, FieldValues } from "react-hook-form";
import { type CommonCopy } from "@/i18n";

export type CdcTelephoneFieldCopy = FieldCopy & {
  label: string;
  dialCodeLabel: string;
  dialCodePlaceholder: string;
  placeholder?: string;
  errors?: Record<string, string>;
};

export type CdcTelephoneFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  TelephoneFieldProps<TFieldValues, TName>,
  | "fieldKey"
  | "options"
  | "label"
  | "placeholder"
  | "dialCodesLabel"
  | "dialCodesPlaceholder"
  | "description"
> & {
  locale: LocaleKey;
};

export function CdcTelephoneField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ locale, ...rest }: Readonly<CdcTelephoneFieldProps<TFieldValues, TName>>) {
  const { label, placeholder, dialCodeLabel, dialCodePlaceholder } =
    getFieldCopy(locale, "telephone") as unknown as CdcTelephoneFieldCopy;
  const { errors: requiredLabel } = getFieldCopy(
    locale,
    "common",
  ) as unknown as CommonCopy;

  return (
    <TelephoneField
      {...rest}
      label={label}
      placeholder={placeholder}
      dialCodesLabel={dialCodeLabel}
      dialCodesPlaceholder={dialCodePlaceholder}
      requiredLabel={requiredLabel.required}
    />
  );
}
